import styled from 'styled-components';

export const StyledPartnerProgress = styled.section`
	background: #efefef;
	padding-top: 120px;
	padding-bottom: 120px;

	.single-image{
		margin-bottom: 30px;
	}
    @media (max-width: 767px) {
        .row {
            .col-md-4{
                margin-bottom: 20px;
                &:last-child{
                    margin-bottom: 0;
                }
            }
        }

        .title {
            text-align: left !important;;

            h3 {
                text-align: left !important;
            }
        }
    }
	
`